import { Component, Input, OnInit, input } from "@angular/core";
import { CommonModule, formatDate } from "@angular/common";
import { MatCard, MatCardContent, MatCardTitle } from "@angular/material/card";
import { getStatusCodeValue, getStatusColor } from "../../../utils/caseStatusCode.domain";
import { CaseDialogComponent } from "../case-dialog/case-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import type { Case } from "../../../interfaces/case.interface";
import { ActivatedRoute, Router } from "@angular/router";
import { AttendanceStatus } from "../../../interfaces/course.interface";
import { MatDividerModule } from "@angular/material/divider";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-case-card",
    standalone: true,
    imports: [MatCard, MatCardContent, MatCardTitle, MatDividerModule, MatIcon, CommonModule],
    templateUrl: "./case-card.component.html",
    styleUrl: "./case-card.component.scss"
})
export class CaseCardComponent implements OnInit {
    @Input() case!: Case;
    readonly index = input.required<number>();

    caseTestId: string = "case-card-";
    private isDialogOpen = false;

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            if (params["caseId"] === this.case.ticketnumber) {
                this.openCaseDialog();
            }
        });
    }

    public get AttendanceStatus(): typeof AttendanceStatus {
        return AttendanceStatus;
    }
    formatDate = formatDate;
    getStatusCodeValue = getStatusCodeValue;
    getStatusColor = getStatusColor;

    openCaseDialog() {
        // prevents a bug where the dialog opens multiple times
        if (this.isDialogOpen) return;
        this.isDialogOpen = true;

        const dialogRef = this.dialog.open(CaseDialogComponent, {
            data: this.case,
            width: "100%",
            height: "auto",
            maxWidth: "992px",
            maxHeight: "90vh",
            disableClose: true,
            panelClass: "case-dialog"
        });

        dialogRef.afterOpened().subscribe(() => {
            this.router.navigate([], {
                queryParams: { caseId: this.case.ticketnumber },
                queryParamsHandling: "merge"
            });
        });

        dialogRef.afterClosed().subscribe(() => {
            this.isDialogOpen = false;
        });

        return dialogRef;
    }
}
